import { RootState } from 'types';

export const selectFormValue = (state: RootState) =>
  state?.ewdRegistrationState?.formValue;
export const selectFormData = (state: RootState) =>
  state?.ewdRegistrationState?.formData;
export const selectDiagonosissUpload = (state: RootState) =>
  state?.ewdRegistrationState?.diagonosisPayloadUpload;
